import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllOrder = async (params: any) => {
  const url = endpoints.ORDER;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const resendEmail = async (params: any) => {
  const url = endpoints.ORDER + "/resend";

  const { data: response } = await axios.post(
    url,
    { order_id: params },
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const changeEmail = async (orderId: string, newEmail: string) => {
  const url = endpoints.ORDER + `/${orderId}/email`;

  const { data: response } = await axios.patch(
    url,
    { email: newEmail },
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const orderService = {
  getAllOrder,
  resendEmail,
  changeEmail,
};

export default orderService;
